const TMSException = (params) => {
 
    if (params.data.ticket_type == 'transit_delay') {
        return <i className="icofont icofont-clock-time f20" style={{ color: "#FF5370" }}></i>
    }
    else if (params.data.ticket_type == 'no_gps') {
        return <i className="icofont icofont-social-google-map txt-secondary f20"></i>
    }
    else if (params.data.ticket_type == 'overspeeding') {
        return <i className="fa fa-tachometer f20" style={{ color: "#3300c2" }}></i>
    }
    else if (params.data.ticket_type == 'night_driving') {
        return <i className="icofont icofont-full-night f20" style={{ color: "#ab8ce4" }}></i>
    }
    else if (params.data.ticket_type == 'enroute_stoppage') {
        return <i className="icofont icofont-pause f20" style={{ color: "#a34518" }}></i>
    }
    else if (params.data.ticket_type == 'loading_delay') {
        return <i className="icofont icofont-truck-alt f20" style={{ color: "#d3a337" }}></i>
    }
    else if (params.data.ticket_type == 'unloading_delay') {
        return <i className="icofont icofont-truck-loaded f20" style={{ color: "#7ad337" }}></i>
    }
    else if (params.data.ticket_type == 'slow_trucks') {
        return <i className="fa fa-truck darkorange f20"></i>
    }
    else {
        return (<></>)
    }
}
export default TMSException